import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://priem.mirea.ru/tools/priem-styles/main.css';
document.head.appendChild(link);

window.addEventListener("message", (event) => {
  if (event.origin !== "https://priem.mirea.ru") return;
  if (event.data.type === "auth-success") {
    // действия: редирект, перезагрузка и т.д.
  }
  if (event.data.type === "resize") {
    const iframe = document.getElementById("loginIframe");
    if (iframe && event.data.height) {
      iframe.style.height = event.data.height + "px";
    }
  }
});

root.render(
  <React.StrictMode>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
